import * as GeneralApi from '../../services/General'
import * as GeneralTypes from '../types/General'

export const loadAllItemsAction = () => async (dispatch) => {
  dispatch({ type: GeneralTypes.LOAD_ALL_ITEMS_START })
  return GeneralApi.loadAllItemsApi()
    .then((data) => {
      dispatch({
        type: GeneralTypes.LOAD_ALL_ITEMS_SUCCESS,
        payload: data,
      })
    })
    .catch((error) => {
      dispatch({ type: GeneralTypes.LOAD_ALL_ITEMS_FAILED })
      console.log(error)
    })
}

export const getIndexAction =
  (id) => async (dispatch) => {
    dispatch({ type: GeneralTypes.LOAD_INDEX_CLEAR })
    dispatch({ type: GeneralTypes.LOAD_INDEX_START })
    dispatch({ type: GeneralTypes.LOAD_DAILY_DATA_CLEAR })
    return GeneralApi.getIndexApi(id)
      .then((data) => {
        dispatch({
          type: GeneralTypes.LOAD_INDEX_SUCCESS,
          payload: data,
        })
      })
      .catch((error) => {
        dispatch({ type: GeneralTypes.LOAD_INDEX_FAILED })
        console.log(error)
      })
  }

export const getDailyDataAction =
  (data) => async (dispatch) => {
    dispatch({ type: GeneralTypes.LOAD_DAILY_DATA_START })
    const formData = new FormData()

    formData.append('params_json', JSON.stringify(data))

    return GeneralApi.getDailyDataApi(formData)
      .then((data) => {
        dispatch({
          type: GeneralTypes.LOAD_DAILY_DATA_SUCCESS,
          payload: data,
        })
      })
      .catch((error) => {
        dispatch({ type: GeneralTypes.LOAD_DAILY_DATA_FAILED })
        console.log(error)
      })
  }